import React from 'react';
import { Modal, DropdownSelector, TextInput } from 'hyperdb-utils';

const ModalAttachBooking = ({
  selectedType, searchReference, relatedObjects, selectedReference, loading = false,
  onChange, onSearch, onSubmit, onClose,
}) => {
  const selectedBooking = selectedReference
    ? relatedObjects.find(o => o.reference === selectedReference)
    : null;
  const sortedRelatedObjects = (relatedObjects || []);
  sortedRelatedObjects.sort((a, b) => a.reference.localeCompare(b.reference));
  return (
    <Modal title="Attach to inquiry/reservation" onClose={ onClose } onAccept={ onSubmit } loading={ loading }>
      <div className="row">
        <div className="col-md-3">
          <DropdownSelector
            label="Type"
            name="type"
            value={ selectedType }
            options={ [{ name: 'Inquiry', value: 'inquiry' }, { name: 'Reservation', value: 'reservation' }] }
            onChange={ onChange.bind(null, 'selectedType') }
          />
        </div>
        <div className="col-md-3">
          <TextInput
            label="Reference"
            name="reference"
            value={ searchReference }
            onChange={ onChange.bind(null, 'searchReference') }
          />
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>&nbsp;</label>
            <div><button type="button" className="btn btn-sm btn-primary" onClick={ onSearch }disabled={ loading || !searchReference }>Search</button></div>
          </div>
        </div>
      </div>
      {
        relatedObjects
          ? <DropdownSelector
              label={ null }
              placeholder="--- Select ---"
              value={ selectedReference }
              options={ sortedRelatedObjects.map(o => ({ name: o.reference, value: o.reference })) }
              onChange={ onChange.bind(null, 'selectedReference') }
            />
          : null
      }
      {
        selectedReference
          ? <div className="row info-reservation">
              <div className="pull-left labels">
                <h5>reference</h5>
                <h5>origin</h5>
                <h5>property</h5>
                <h5>customer</h5>
                <h5>arrival date</h5>
                <h5>departure date</h5>
                <h5>status</h5>
              </div>
              <div>
                <h5>{ selectedBooking.reference }&nbsp;</h5>
                <h5>{ selectedBooking.origin }&nbsp;</h5>
                <h5>{ selectedBooking.property.name }&nbsp;</h5>
                <h5>{ selectedBooking.customer.name }&nbsp;</h5>
                <h5>{ selectedBooking.arrival_date }&nbsp;</h5>
                <h5>{ selectedBooking.departure_date }&nbsp;</h5>
                <h5>{ selectedBooking.status }&nbsp;</h5>
              </div>
            </div>
          : null
      }
    </Modal>
  );
};

export default ModalAttachBooking;



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/components/ModalAttachBooking.jsx